import {COMPANY} from '../../actions/company/companyActionTypes';

const INITIAL_STATE = {
  companiesLoading: true,
  companies: [],
  companyLoading: true,

  singleCompany: {},
  singleCompanyLoading: true,
  avatars: {
    list: [],
    loading: true
  },
  companiesNotifications: {},
  companiesNotificationsLoading: true
};

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case COMPANY.GET_COMPANIES_SUCCESS:
      return {...state, companies: action.payload.data.data, companiesLoading: false};
    case COMPANY.GET_COMPANIES_FAIL:
      return {...state, companies: [], loading: false};
    case COMPANY.GET_COMPANY:
      return {...state, singleCompany: {}, singleCompanyLoading: true};

    case COMPANY.GET_COMPANY_AVATARS_SUCCESS:
      return {...state, avatars: {list: action.payload.data.data, loading: false}};
    case COMPANY.GET_COMPANY_AVATARS_FAIL:
      return {...state, avatars: {list: [], loading: false}};
    case COMPANY.GET_COMPANY_AVATARS:
      return {...state, avatars: {...state.avatars, loading: true}};

    case COMPANY.GET_COMPANY_SUCCESS:
      return {...state, singleCompany: action.payload.data.data, singleCompanyLoading: false};
    case COMPANY.GET_COMPANY_FAIL:
      if(action?.error?.data === 'canceled'){
        return {...state, singleCompany: {}, singleCompanyLoading: true};
      }
      return {...state, singleCompany: {}, singleCompanyLoading: false};

    case COMPANY.GET_COMPANY_NOTIFICATIONS_SUCCESS:
      return {...state, companiesNotifications: action.payload.data, companiesNotificationsLoading: false};
    case COMPANY.GET_COMPANY_NOTIFICATIONS_FAIL:
      return {...state, companiesNotifications: {}, companiesNotificationsLoading: false};

    case COMPANY.RESET_COMPANY:
      return {...state, singleCompany: {}, singleCompanyLoading: true};
    default:
      return state;
  }
}
